import React, { useEffect, useState } from "react";
import { useApiGet } from "../../../api/apiCall";
import { getRecentNoticessUrl } from "../../../api/urls";
import { ApplicationTabs, GlobalMenu, MessageBox } from "../../../ui_elements";
import { LandingModal } from "./containers";
import DOMPurify from "dompurify";
import Hero from "../../../assets/images/home_bg.png";
import styles from "./styles.module.css";
import { APPLICATION_ID, APPLICATION_MODE } from "../../../utils/constants";
import { ArrowUp } from "../../../assets/svgs";
const date = new Date();

const Home = () => {
	const [message, setMessage] = useState(true);
	const [modal, setModal] = useState(false);
	const handleCurrentLink = (linkObject) => {
		if (
			linkObject?.applicationMode === APPLICATION_MODE.UTME ||
			linkObject?.applicationMode === APPLICATION_MODE.DIRECT_ENTRY
		) {
			return {
				pathname: `/generate_jamb_students_invoice`,
				state: { application: linkObject }
			};
		} else if (
			linkObject?.applicationMode === APPLICATION_MODE.PG ||
			linkObject?.applicationMode ===
			APPLICATION_MODE.FOUR_YEAR_SANDWICH ||
			linkObject?.applicationMode === APPLICATION_MODE.FIVE_YEAR_SANDWICH
		) {
			return {
				pathname: `/pg_students_invoice`,
				state: { application: linkObject }
			};
		} else if (
			linkObject?.applicationMode ===
			APPLICATION_MODE.INTER_UNIVERSITY_TRANSFER
		) {
			return {
				pathname: `/generate_inter_university_invoice`,
				state: { application: linkObject }
			};
		} else if (linkObject?.applicationMode === APPLICATION_MODE.CCE) {
			return {
				pathname: `/generate_cce_invoice`,
				state: { application: linkObject }
			};
		} else if (
			linkObject?.applicationMode === APPLICATION_MODE.STAFF_REQUEST
		) {
			return {
				pathname: `/generate_staff_request_invoice`,
				state: { application: linkObject }
			};
		} else if (linkObject?.applicationMode === APPLICATION_MODE.JUPEB) {
			return {
				pathname: `/generate_application_invoice`,
				state: { application: linkObject }
			};
		} else if (linkObject?.applicationMode === APPLICATION_MODE.ND_DIPLOMA) {
			return {
				pathname: `/generate_nd_invoice`,
				state: { application: linkObject }
			};
		} else if (
			linkObject?.applicationMode === APPLICATION_MODE.HND_DIPLOMA
		) {
			return {
				pathname: `/generate_hnd_invoice`,
				state: { application: linkObject }
			};
		}
		else if (
			linkObject?.applicationMode === APPLICATION_MODE.CERTIFICATE_DIPLOMA
		) {
			return {
				pathname: `/generate_certificate_course_invoice`,
				state: { application: linkObject }
			};
		}
		else if(
			linkObject?.applicationMode === APPLICATION_MODE.SUPPLEMENTARY_DIPLOMA
		){
			return {
				pathname: `/generate_supplementary_invoice`,
				state: { application: linkObject }
			};
		}
		else {
			console.log("Not a valid application mode");
		}
	};

	const applicationForms = {
		pg: {
			applicationMode: APPLICATION_MODE.PG,
			id: APPLICATION_ID.PG,
			name: "Postgraduate Application"
		},
		JUPEB: {
			applicationMode: APPLICATION_MODE.JUPEB,
			id: APPLICATION_ID.JUPEB,
			name: "JUPEB"
		},
		ND_DIPLOMA: {
			applicationMode: APPLICATION_MODE.ND_DIPLOMA,
			id: APPLICATION_ID.ND_DIPLOMA,
			name: "National Diploma"
		},
		HND_DIPLOMA: {
			applicationMode: APPLICATION_MODE.HND_DIPLOMA,
			id: APPLICATION_ID.HND_DIPLOMA,
			name: "Higher National Diploma"
		},
		CERTIFICATE_DIPLOMA: {
			applicationMode: APPLICATION_MODE.CERTIFICATE_DIPLOMA,
			id: APPLICATION_ID.CERTIFICATE_DIPLOMA,
			name: "Certificate Courses Diploma"
		},
		SUPPLEMENTARY_DIPLOMA: {
			applicationMode: APPLICATION_MODE.SUPPLEMENTARY_DIPLOMA,
			id: APPLICATION_ID.SUPPLEMENTARY_DIPLOMA,
			name: "Supplementary Diploma"
		},
		UTME: {
			applicationMode: APPLICATION_MODE.UTME,
			id: APPLICATION_ID.UTME,
			name: "Post UTME"
		},
		directEntry: {
			applicationMode: APPLICATION_MODE.DIRECT_ENTRY,
			id: APPLICATION_ID.DIRECT_ENTRY,
			name: "Direct Entry"
		},
		supplementary: {
			applicationMode: APPLICATION_MODE.SUPPLEMENTARY,
			id: APPLICATION_ID.SUPPLEMENTARY,
			name: "Admission Shopping"
		},
		staffRequestForm: {
			applicationMode: APPLICATION_MODE.STAFF_REQUEST,
			id: APPLICATION_ID.STAFF_REQUEST,
			name: "Staff Request"
		},
		fourYearSandwich: {
			applicationMode: APPLICATION_MODE.FOUR_YEAR_SANDWICH,
			id: APPLICATION_ID.FOUR_YEAR_SANDWICH,
			name: "Four Year Sandwich"
		},
		fiveYearSandwich: {
			applicationMode: APPLICATION_MODE.FIVE_YEAR_SANDWICH,
			id: APPLICATION_ID.FIVE_YEAR_SANDWICH,
			name: "Five Year Sandwich"
		},
		interUniversityTransfer: {
			applicationMode: APPLICATION_MODE.INTER_UNIVERSITY_TRANSFER,
			id: APPLICATION_ID.INTER_UNIVERSITY_TRANSFER,
			name: "Inter University Transfer"
		}
	};
	const { data, isFetched } = useApiGet(getRecentNoticessUrl(), {
		keepPreviousData: true
	});

	useEffect(() => {
		if (isFetched) {
			setModal(true);
		}
	}, [isFetched]);

	const applicationTabsInfo = [
		{
			title: "National Diploma",
			formLink: `/nd_login`,
			applicationForm: applicationForms.ND_DIPLOMA
		},
		{
			title: "Higher National Diploma",
			formLink: `/hnd_login`,
			applicationForm: applicationForms.HND_DIPLOMA
		},
		{
			title: "Certificate Courses",
			formLink: `certificate_courses_login`,
			applicationForm: applicationForms.CERTIFICATE_DIPLOMA
		},
		{
			title: "Supplementary",
			formLink: `supplementary_diploma_login`,
			applicationForm: applicationForms.SUPPLEMENTARY_DIPLOMA
		}
	];

	return (
		<>
			{!data?.data || data?.data.length === 0 ? null : (
				<LandingModal
					data={data?.data}
					isOpen={modal}
					closeModal={() => setModal(false)}
				/>
			)}
			{!data?.data ||
				data?.data?.length === 0 ||
				message === false ? null : (
				<MessageBox
					openModal={() => setModal(true)}
					closeMessage={setMessage}
					title={data?.data[0]?.title}
					message={
						<div
							className={`d-flex align-items-baseline ${styles.message_body}`}
						>
							<div
								dangerouslySetInnerHTML={{
									__html: DOMPurify.sanitize(
										data?.data[0]?.description.slice(0, 70)
									)
								}}
							/>
							<span>....</span>
						</div>
					}
				/>
			)}
			<GlobalMenu isLanding={"unAuthenticated"} />
			<main className={`${styles.container}`}>
				<div className={styles.firstCover}>
					<h1>
						Welcome to Abia State College of <br />
						Health Sciences & Management <br />
						Technology, Portal
					</h1>
					<p className="mb-4">
						Discover a rewarding career in healthcare and management
					</p>
				</div>
				<img src={Hero} alt="landing_img" />
			</main>

			<ApplicationTabs
				items={applicationTabsInfo}
				handleCurrentLink={handleCurrentLink}
			/>
			<footer
				className={`d-flex flex-column align-items-center justify-content-center mt-5 ${styles.home_footer}`}
			>
				<p className={`${styles.call_centre_number}`}>
					Need help? <span>-</span> <span>08139833300</span>
				</p>
				<p className={styles.copyright}>
					{`Copyright©️ ${date.getFullYear()} All rights reserved by Abia State College of Health Sciences & Management Technology. Powered by Tenece`}
				</p>
				<div
					className={`${styles.fab} d-flex align-items-center justify-content-center`}
					onClick={() =>
						window.scrollTo({
							top: 0,
							behavior: "smooth"
						})
					}
				>
					<ArrowUp />
				</div>
			</footer>
		</>
	);
};

export default Home;
